import type { User } from './types/User';

import { routes } from '@/constants/Constants';
import { LLTypes } from './types/User';

export type Options = { label: string; value: string };

export const generateYearsOptions = (firstYear: number, lastYear: number): Options[] => {
  const years: Options[] = [];
  for (let i = lastYear; i >= firstYear; i--) {
    years.push({ value: `${i}`, label: `${i}` });
  }
  return years;
};

export const checkIfPmi = (user: { email: string; partner?: string }) => {
  return (
    /@pmi|@propertymanagementinc\.com$|pmi\.com$|pmi@theguarantors.com$/.test(user.email) ||
    user.partner === 'property-management-inc'
  );
};

export const shouldDisableRenterInvite = (user?: User) => {
  return user?.status && !user.status.hasProperties;
};

export const shouldUserStayInEnrollProperty = (pathname: string, user?: User) => {
  return !!user?.status?.isNewSelfServiceUser && pathname !== routes.enrollNotEligible;
};

export const showSmbInvite = (user: User) => {
  return user && (user.LLType === LLTypes.SMB || checkIfPmi(user));
};

// function that is responsible for checking if the email is not a QA email
export const userShouldBeIdentifiedForUserPilot = (email: string) => {
  // Exclude emails that start with "qa." unless they contain "userpilot"
  if (email.startsWith('qa.') && !email.includes('userpilot')) {
    return false;
  }
  return true;
};
